export const ApplicationCheckoutTypeArray = ['ADOPTION_FEE', 'DISCOUNT', 'LICENSE', 'PRODUCT', 'DONATION', 'FIXED_FEE', 'VOUCHER', 'TAX', 'ADDITION', 'SPAY_NEUTER'] as const
export type ApplicationCheckoutType = typeof ApplicationCheckoutTypeArray[number]

export default interface IAdoptionApplicationCheckout {
  id?: number,
  uuid: string,
  json: object | null,
  type_key: string,
  price: number,
  base_percentage_fee: number,
  base_result_fee: number,
  expected_result_fee: number,
  expected_percentage_fee: number,
  final_result_fee: number,
  final_percentage_fee: number,
  transfer_fee: number
}